import * as React from "react";
import { isFunction, isObject } from "lodash";
import TooltipMessage from "../styles/TooltipMessage.js";
import Container from "../styles/Container.js";
const ToolTipContent = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { active, 'data-testid': dataTestId, direction = 'top', locator, message, noWrap, style } = props;
    const isMessageString = !isFunction(message) && !isObject(message);
    return /*#__PURE__*/ React.createElement(Container, {
        "aria-hidden": !active,
        className: locator,
        direction: direction,
        noWrap: noWrap,
        ref: ref,
        style: style
    }, isMessageString && /*#__PURE__*/ React.createElement(TooltipMessage, {
        "data-testid": dataTestId
    }, message), !isMessageString && message);
});
export default ToolTipContent;
